<app-wait *ngIf="loading"></app-wait>

<div *ngIf="!loading" class="expired-password suif-panel">
    <h1 class="suif-panel-title-dark">Reset Password</h1>

    <app-wait *ngIf="submitting" wait-text="Please wait while we resend your email."></app-wait>

    <app-message-box *ngIf="errors.serviceUnavailable" serviceUnavailable></app-message-box>
    <app-message-box *ngIf="errors.unexpectedError" unexpectedError></app-message-box>
    <app-message-box *ngIf="successful" level="success">The email was successfully resent.</app-message-box>
    <app-message-box *ngIf="previousStateError === 'inviteAcceptError'" level="error" prominent="Oops, there was an error in processing your invitation.">
        Until we get this sorted out, you won't be able to see all of your requests.
        <a routerLink="/inviteSignup/processInvite" [queryParams]="{passwordExpired: true}"><strong>Try again now</strong></a>.
    </app-message-box>


    <h2 class="suif-h3">Your password has expired. Check your email to reset your password.</h2>

    <p>
        You should receive an email momentarily to <strong>{{emailAddress}}</strong>.
        If you don't see it, check your spam folder, or
        <button type="button" class="button-link" (click)="resendEmail()">send another email now.</button>
    </p>
    <div *ngIf="accountRecoveryAvailable">Can't access your email account? <a routerLink="/account-recovery-workflow" [queryParams]="{emailAddress: emailAddress}">Try to Recover Your Account</a></div>
</div>
